import React from "react";
import { OneRow } from "../../core/layouts";
import UserListingContainer from "../../containers/UserListingContainer";

const UserListingView = () => {
  return <OneRow section={<UserListingContainer />} />;
};

export default UserListingView;
